import { render } from "./SettingsPage.vue?vue&type=template&id=2d9a9fff"
import script from "./SettingsPage.vue?vue&type=script&lang=js"
export * from "./SettingsPage.vue?vue&type=script&lang=js"

import "@/css/GuestsPage.css?vue&type=style&index=0&lang=css&external"
import "@/css/AppLayout.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__